import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";

import {
  useEffect,
  useState,
} from "react";

import routes from "./routes";

import { Toaster } from "./components/toaster";

import ProtectedRoute from "./routes/ProtectedRoute";

import Login from "./views/Auth/Login";
import ForgotPassword from "./views/Auth/ForgotPassword";
import Register from "./views/Auth/Registration";
import VerifyOtp from "./views/Auth/Verification";
import CompleteProfile from "./views/Auth/CompleteProfile";

import Dashboard from "./views/Dashboard";
import Referrals from "./views/Referrals";
import CommissionHistory from "./views/CommissionHistory";
import Profile from "./views/Profile";
import Analytics from "./views/Analytics";
import ResetPasswordConfirm from "./views/Auth/ForgotPassword/ResetPassword";
import Support from "./views/Support";
import SupportTickets from "./views/Support/components/SupportTickets";
import SupportGuidePage from "./views/Support/components/SupportGuidePage";
import Notifications from "./views/Notifications/Notifications";

import SessionExpiredModal from "./components/SessionExpiredModal";

import {
  setSessionExpiredHandler,
} from "./utils/sessionExpired";

const AppContent = () => {
  const navigate =
    useNavigate();

  const [
    sessionExpiredVisible,
    setSessionExpiredVisible,
  ] = useState(false);

  useEffect(() => {
    setSessionExpiredHandler(
      () => {
        setSessionExpiredVisible(
          true
        );
      }
    );
  }, []);

  return (
    <>
      <Routes>
        <Route
          path={
            routes.login
          }
          element={<Login />}
        />

        <Route
          path={
            routes.register
          }
          element={
            <Register />
          }
        />

        <Route
          path={
            routes.verifyOtp
          }
          element={
            <VerifyOtp />
          }
        />

        <Route
          path={
            routes.forgotPassword
          }
          element={
            <ForgotPassword />
          }
        />

        <Route
          path={
            routes.resetPasswordConfirm
          }
          element={
            <ResetPasswordConfirm />
          }
        />

        <Route
          element={
            <ProtectedRoute />
          }
        >
          <Route
            path={
              routes.completeProfile
            }
            element={
              <CompleteProfile />
            }
          />

          <Route
            path={
              routes.dashboard
            }
            element={
              <Dashboard />
            }
          />

          <Route
            path={
              routes.recruits
            }
            element={
              <Referrals />
            }
          />

          <Route
            path={
              routes.commissions
            }
            element={
              <CommissionHistory />
            }
          />

          <Route
            path={
              routes.settings
            }
            element={
              <Profile />
            }
          />

          <Route
            path={
              routes.support
            }
            element={
              <Support />
            }
          />

          <Route
            path={
              routes.supportTickets
            }
            element={
              <SupportTickets />
            }
          />

          <Route
            path={
              routes.supportHelp
            }
            element={
              <SupportGuidePage />
            }
          />

          <Route
            path={
              routes.notifications
            }
            element={
              <Notifications />
            }
          />

          <Route
            path={
              routes.analytics
            }
            element={
              <Analytics />
            }
          />
        </Route>
      </Routes>

      <SessionExpiredModal
        open={
          sessionExpiredVisible
        }
        onLogin={() => {
          setSessionExpiredVisible(
            false
          );

          navigate(
            routes.login
          );
        }}
      />
    </>
  );
};

function App() {
  return (
    <>
      <Toaster />

      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </>
  );
}

export default App;